import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    stepDetail: null,
    loading: false,
    error: null,
    registrationStatus: 'idle',
};
export const publicAssessmentSlice = createSlice({
    name: 'publicAssessment',
    initialState,
    reducers: {
        fetchStepDetails(state, _action) {
            state.loading = true;
            state.error = null;
        },
        storeStepDetails(state, action) {
            state.stepDetail = action.payload;
            state.loading = false;
            state.error = null;
        },
        setStepDetailsError(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        setRegistrationStatus(state, action) {
            state.registrationStatus = action.payload;
        },
    },
});
export const { fetchStepDetails, storeStepDetails, setStepDetailsError, setRegistrationStatus } = publicAssessmentSlice.actions;
export default publicAssessmentSlice.reducer;
